import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import logo from "../../../assets/img/vibelogo.png";
import GroupIcon from "@mui/icons-material/Group";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectUser } from "../../../redux/features/userSlice";
import { onValue, ref } from "firebase/database";
import { db } from "../../../firebaseConfig";
import PersonIcon from "@mui/icons-material/Person";
import { Fade } from "react-reveal";

export default function Sidebar({
  isOverview,
  isTherapists,
  isClients,
  isProfile,
}) {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const [therapistIsTheUser, setTherapistIsTheUser] = useState(false);
  const [therapistsIDS, setTherapistsIDS] = useState([]);
  const [mobileWidth, setIsMobileWidth] = useState(false);
  const [isProfileLoaded, setIsProfileLoaded] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Subscribe to real-time updates
    const starCountRef = ref(db, "therapists");
    const unsubscribe = onValue(starCountRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const therapistIDs = Object.values(data).map((item) => {
          if (item) {
            return item.uid;
          }
          return null; // handle null or undefined values if necessary
        });
        setTherapistsIDS(therapistIDs.filter((id) => id)); // Filter out null values
      }
    });
    // Cleanup the subscription on component unmount
    return () => {
      unsubscribe();
    };
  }, [user?.uid]);

  useEffect(() => {
    if (therapistsIDS.includes(user?.uid)) {
      setTherapistIsTheUser(true);
    } else {
      setTherapistIsTheUser(false);
    }
  }, [therapistsIDS, user?.uid]);

  useEffect(() => {
    window.innerWidth < 732 ? setIsMobileWidth(true) : setIsMobileWidth(false);

    window.addEventListener("resize", () =>
      window.innerWidth < 732 ? setIsMobileWidth(true) : setIsMobileWidth(false)
    );
  }, []);

  return (
    <Fade left>
      <div className={`sidebar`}>
        <div className="sidebar-container">
          <Link to={"/"} className="logo">
            <img src={logo} className="logo-img" alt="vibes&vent logo" />
          </Link>
          {/* <h2>Main Menu</h2> */}
          <nav>
            {/* {user && ( */}
            {process.env.REACT_APP_AUTHORIZED_EMAILS?.split(",").includes(
              user?.email
            ) && (
              <Link
                to={"/overview"}
                className={`bar-option ${isOverview && "active"}`}
              >
                <DashboardIcon className="bar-icon" />
                <p>Overview</p>
              </Link>
            )}
            {/* )} */}

            <Link
              to={"/therapists"}
              className={`bar-option ${isTherapists && "active"} `}
            >
              <AssignmentIndIcon className="bar-icon" />
              <p>Therapists</p>
            </Link>

            {/* {user && ( */}
            {process.env.REACT_APP_AUTHORIZED_EMAILS?.split(",").includes(
              user?.email
            ) && (
              <Link
                to={"/clients"}
                className={`bar-option ${isClients && "active"} `}
              >
                <GroupIcon className="bar-icon" />
                <p>Clients</p>
              </Link>
            )}
            {/* )} */}
          </nav>
          <div className="sidebar-bottom">
            {user && (
              <Link
                to={`${
                  therapistIsTheUser
                    ? `/therapist/${user?.uid}`
                    : `/profile/${user?.uid}`
                }`}
                className="user-details"
              >
                {user && isProfileLoaded ? (
                  <img
                    src={user?.photoURL}
                    className="icon"
                    alt={`${user?.displayName}`}
                  />
                ) : (
                  <div className="icon">
                    <PersonIcon />
                  </div>
                )}
                <p style={isProfile ? { color: "#ff7f50" } : {}}>
                  {mobileWidth
                    ? user?.displayName?.split(" ")[0]
                    : user?.displayName}
                </p>
              </Link>
            )}

            {user && (
              <Link
                to={"/"}
                onClick={() => {
                  dispatch(logout());
                }}
                style={{ color: "red", marginTop: 20 }}
              >
                Logout{" "}
              </Link>
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}
